import cn from 'classnames';
import React, { FC, memo, useMemo } from 'react';

import isEqual from 'lodash/isEqual';

import Typography from '@mui/material/Typography';

import { getTokenListForUi } from '@utils/tokens.utils';

import TokensIcon from '@components/common/TokensIcon';

import { Size, TokenSize } from '@constants/common/ui.constants';

import { VaultFarmsType } from '@app-types/vaults/vault.types';

import useStyles from './styles.module';

interface Props {
  className?: string;
  farm: VaultFarmsType;
  selectedFarm: VaultFarmsType;
  onCLick: () => void;
  size?: Size;
  hideTokenSymbol?: boolean;
}

const FarmButton: FC<Props> = ({
  className,
  onCLick,
  selectedFarm,
  farm: { farm, farmInfo },
  hideTokenSymbol = false,
  size = Size.Large,
}) => {
  const isActive = useMemo(
    () => isEqual(selectedFarm.farm.farmId, farm.farmId),
    [farm, selectedFarm],
  );

  const { classes } = useStyles({ isActive, size });

  return (
    <button className={cn(classes.box, className)} onClick={onCLick}>
      <TokensIcon
        size={TokenSize.Large}
        tokens={getTokenListForUi(farmInfo.stakingToken)}
      />
      {!hideTokenSymbol && (
        <Typography variant="body2">{farmInfo.stakeTokenSymbol}</Typography>
      )}
    </button>
  );
};

export default memo(FarmButton);
